/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1BannerBanneridLangsMutationRequest,
  PostApiV1BannerBanneridLangsMutationResponse,
  PostApiV1BannerBanneridLangsPathParams,
  PostApiV1BannerBanneridLangs400,
  PostApiV1BannerBanneridLangs401,
  PostApiV1BannerBanneridLangs404,
  PostApiV1BannerBanneridLangs500,
} from "../../types/bannerIdiomasController/PostApiV1BannerBanneridLangs.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1BannerBanneridLangs } from "../../clients/bannerIdiomasController/postApiV1BannerBanneridLangs.ts";

export const postApiV1BannerBanneridLangsMutationKey = () =>
  [{ url: "/api/v1/banner/:bannerId/langs" }] as const;

export type PostApiV1BannerBanneridLangsMutationKey = ReturnType<
  typeof postApiV1BannerBanneridLangsMutationKey
>;

export function postApiV1BannerBanneridLangsMutationOptions<TContext = unknown>(
  config: Partial<
    RequestConfig<PostApiV1BannerBanneridLangsMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1BannerBanneridLangsMutationKey();
  return mutationOptions<
    PostApiV1BannerBanneridLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1BannerBanneridLangs400
      | PostApiV1BannerBanneridLangs401
      | PostApiV1BannerBanneridLangs404
      | PostApiV1BannerBanneridLangs500
    >,
    {
      bannerId: PostApiV1BannerBanneridLangsPathParams["bannerId"];
      data?: PostApiV1BannerBanneridLangsMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ bannerId, data }) => {
      return postApiV1BannerBanneridLangs(bannerId, data, config);
    },
  });
}

/**
 * @description Cria uma nova tradução (idioma) para o banner (multipart/form-data). **(Requer Authorization para autenticação)**
 * @summary Criar idioma do banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/:bannerId/langs}
 */
export function usePostApiV1BannerBanneridLangs<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1BannerBanneridLangsMutationResponse,
      ResponseErrorConfig<
        | PostApiV1BannerBanneridLangs400
        | PostApiV1BannerBanneridLangs401
        | PostApiV1BannerBanneridLangs404
        | PostApiV1BannerBanneridLangs500
      >,
      {
        bannerId: PostApiV1BannerBanneridLangsPathParams["bannerId"];
        data?: PostApiV1BannerBanneridLangsMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1BannerBanneridLangsMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1BannerBanneridLangsMutationKey();

  const baseOptions = postApiV1BannerBanneridLangsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1BannerBanneridLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1BannerBanneridLangs400
      | PostApiV1BannerBanneridLangs401
      | PostApiV1BannerBanneridLangs404
      | PostApiV1BannerBanneridLangs500
    >,
    {
      bannerId: PostApiV1BannerBanneridLangsPathParams["bannerId"];
      data?: PostApiV1BannerBanneridLangsMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PostApiV1BannerBanneridLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1BannerBanneridLangs400
      | PostApiV1BannerBanneridLangs401
      | PostApiV1BannerBanneridLangs404
      | PostApiV1BannerBanneridLangs500
    >,
    {
      bannerId: PostApiV1BannerBanneridLangsPathParams["bannerId"];
      data?: PostApiV1BannerBanneridLangsMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1BannerBanneridLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1BannerBanneridLangs400
      | PostApiV1BannerBanneridLangs401
      | PostApiV1BannerBanneridLangs404
      | PostApiV1BannerBanneridLangs500
    >,
    {
      bannerId: PostApiV1BannerBanneridLangsPathParams["bannerId"];
      data?: PostApiV1BannerBanneridLangsMutationRequest;
    },
    TContext
  >;
}
